module.exports = __webpack_public_path__ + "img/图片4.b14661b5.png";